<template>
  <el-dialog
    class="dialog"
    title="添加发送对象"
    width="50%"
    :visible.sync="showAddPerson.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :model="form"
      ref="form"
      :rules="rules"
    >
      <el-form-item label="姓名：" prop="name">
        <el-input placeholder="请输入姓名" v-model="form.name" />
      </el-form-item>
      <el-form-item label="手机号码：" prop="mobile">
        <el-input placeholder="请输入手机号码" v-model="form.mobile" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <butn
        class="czButn"
        @click="cancel"
        size="small"
        title="取 消"
      />
      <butn type="primary" @click="confirm" size="small" title="提 交" />
    </span>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { validMobile } from "@/utils/rules/validMobile.js";
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: {
    showAddPerson: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: "",
        mobile: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"]
          }
        ],
        mobile: [
          {
            required: true,
            validator: validMobile,
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  created() {
    vue.$on("addMember", () => {
      this.dialogVisible = true;
    });
  },
  methods: {
    confirm() {
      this.$refs["form"].validate(res => {
        if (res) {
          this.$emit("addPersonHandle", {
            userName: this.form.name,
            userMobile: this.form.mobile
          });
          this.dialogVisible = false;
        }
      });
    },
    // dialog关闭时重置状态
    close() {
      this.$refs["form"].resetFields();
    },
    cancel() {
      this.$emit("closeAddPerson");
    },
  },
  beforeDestroy() {
    vue.$off("addMember");
  }
};
</script>

<style lang="scss" scoped>
.form {
  /deep/ .el-form-item:last-child {
    margin-top: 30px !important;
  }
}
</style>
